function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Formik } from 'formik';
import React, { useContext, useImperativeHandle, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { useWizard } from 'react-use-wizard';
import * as yup from 'yup';
import FormFooter from '../../../components/form/FormikFormFooter';
import { softwares } from '../../../components/mapView/constants';
import { FORCE_JOB_UPDATE_MODAL } from '../../../components/modal/forceJobUpdateModal';
import Step from '../../../components/wizard/Step';
import useBreakpoint from '../../../hooks/useBreakpoint';
import { commitJob, commitOrder, getJob, showModal, updateJob } from '../../../redux/actions';
import text from '../../../text';
import { client } from '../../../utilities/api';
import { getNowDate } from '../../../utilities/date';
import { isJobPayable } from '../../../utilities/job';
import { isMembershipPriceId } from '../../../utilities/membership';
import { getProjectName } from '../../../utilities/project';
import { isStaff } from '../../../utilities/user';
import ProjectDetailsForm from '../ProjectDetailsForm/Form';
import { PaymentContext } from '../PaymentContext';
import { MapViewContext } from '../../../components/mapView/mapViewContext';
import routes from '../../../routes/constants';
var validationSchema = yup.object({
    customer_software: yup.string().oneOf([
        'autodesk_revit',
        'autodesk_autocad',
        'graphisoft_archicad',
        'bentley',
        'vectorworks',
        'rhinoceros_rhino',
        'sketchup_scan_plugin'
    ]).required(text('required')),
    message: yup.string().nullable().optional(),
    projectId: yup.number(),
    projectName: yup.string().required(text('pleaseSelectOrCreateProject')).typeError(text('pleaseTypeProjectName'))
});
var ProjectDetailsStep = function() {
    var _job_project;
    var history = useHistory();
    var isBreakpointEnabled = useBreakpoint([
        'xs',
        'sm'
    ]);
    var jobId = useParams().jobId;
    var _useSelector = useSelector(function(state) {
        return {
            job: state.jobsReducer.job,
            membershipPriceId: state.order.membershipPriceId,
            currentUser: state.profileReducer.userProfile
        };
    }), job = _useSelector.job, currentUser = _useSelector.currentUser, membershipPriceId = _useSelector.membershipPriceId;
    var dispatch = useDispatch();
    var _useWizard = useWizard(), nextStep = _useWizard.nextStep, previousStep = _useWizard.previousStep;
    var _useContext = useContext(PaymentContext), wizzardFunctions = _useContext.refs.wizzardFunctions;
    var _useContext1 = useContext(MapViewContext), buyNowData = _useContext1.state.buyNowData;
    useImperativeHandle(wizzardFunctions, function() {
        return {
            previousStep: previousStep
        };
    });
    var isRequestQuote = useMemo(function() {
        return buyNowData.length === 0 && !isMembershipPriceId(membershipPriceId);
    }, [
        buyNowData.length,
        membershipPriceId
    ]);
    var footerButtonLabel = useMemo(function() {
        if (isRequestQuote) {
            return text('requestQuote');
        }
        if (isBreakpointEnabled) {
            return text('continue ');
        }
        if (isStaff(currentUser.role) || !isJobPayable(job) && !isMembershipPriceId(membershipPriceId)) {
            return text('continueToConfirm');
        } else {
            return text('continueToPaymentMethod');
        }
    }, [
        currentUser.role,
        isBreakpointEnabled,
        isRequestQuote,
        job,
        membershipPriceId
    ]);
    var onUpdateJob = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(values) {
            var customer_software, message, force, projectId, updatedJob;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        customer_software = values.customer_software, message = values.message, force = values.force, projectId = values.projectId;
                        return [
                            4,
                            updateJob({
                                customer_software: customer_software,
                                point_cloud_format: softwares.entities[customer_software].format,
                                mergeProjectId: projectId,
                                message: message,
                                jobId: jobId,
                                updatedAt: getNowDate(),
                                force: force,
                                onConflict: function() {
                                    onShowForceUpdateModal(values);
                                }
                            })(dispatch)
                        ];
                    case 1:
                        updatedJob = _state.sent();
                        if (updatedJob && !isRequestQuote) {
                            nextStep();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onUpdateJob(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var onShowForceUpdateModal = function(values) {
        dispatch(showModal(FORCE_JOB_UPDATE_MODAL, {
            onSubmit: /*#__PURE__*/ _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                onUpdateJob(_object_spread_props(_object_spread({}, values), {
                                    force: true
                                }))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })
        }));
    };
    var commit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var order;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            commitOrder(jobId)(dispatch)
                        ];
                    case 1:
                        order = _state.sent();
                        if (!order) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            commitJob(jobId, null)(dispatch)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function commit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(values) {
            var _job_project, projectName, projectId, data, data1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        projectName = values.projectName;
                        if (!values.projectId) return [
                            3,
                            1
                        ];
                        projectId = values.projectId;
                        return [
                            3,
                            5
                        ];
                    case 1:
                        if (!((_job_project = job.project) === null || _job_project === void 0 ? void 0 : _job_project.id)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            client.updateProjectName(job.project.id, projectName)
                        ];
                    case 2:
                        data = _state.sent().data;
                        projectId = data.project.id;
                        return [
                            3,
                            5
                        ];
                    case 3:
                        console.warn('no associated project found, creating new project...');
                        return [
                            4,
                            client.createProject(projectName)
                        ];
                    case 4:
                        data1 = _state.sent().data;
                        projectId = data1.project.id;
                        _state.label = 5;
                    case 5:
                        console.assert(projectId);
                        return [
                            4,
                            onUpdateJob(_object_spread({
                                force: false,
                                projectId: projectId
                            }, values))
                        ];
                    case 6:
                        _state.sent();
                        // unecessary getJob???
                        return [
                            4,
                            getJob(jobId)
                        ];
                    case 7:
                        _state.sent();
                        if (!isRequestQuote) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            commit()
                        ];
                    case 8:
                        _state.sent();
                        history.push({
                            pathname: routes.statusPage.url('success')
                        });
                        _state.label = 9;
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(Formik, {
        validateOnMount: true,
        validateOnChange: true,
        initialValues: {
            projectId: job === null || job === void 0 ? void 0 : (_job_project = job.project) === null || _job_project === void 0 ? void 0 : _job_project.id,
            projectName: getProjectName(job === null || job === void 0 ? void 0 : job.project),
            customer_software: (job === null || job === void 0 ? void 0 : job.customer_software) || '',
            message: job === null || job === void 0 ? void 0 : job.message
        },
        validationSchema: validationSchema,
        onSubmit: handleSubmit
    }, function(param) {
        var isValid = param.isValid;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Step, null, /*#__PURE__*/ React.createElement(ProjectDetailsForm, null)), /*#__PURE__*/ React.createElement(FormFooter, {
            disabled: !isValid,
            label: footerButtonLabel
        }));
    });
};
export default ProjectDetailsStep;
